import React, { Component } from 'react';
import * as styled from './main.styled';
import $ from 'jquery';
import About from '../components/about/about';
import Menu from '../components/menu/menu';
import Logo from '../components/logo/logo';
import Scroller from '../components/scroller/scroller';
import ResizeObserver from 'react-resize-observer';
import Grid from '../components/grid/grid';
import Magnify from '../components/magnify/magnify';

class Main extends Component {

    constructor() {
        super();
        this.main = React.createRef();
        this.state = {
            screenHeight: window.innerHeight
        };
    }

    onResize() {
        if (this.main.current) {
            this.setState((state) => {
                return {...state, screenHeight: window.innerHeight};
            });
        }
    }

    isMobileVersion() {
        return window.innerHeight >= window.innerWidth;
    }

    render() {
        return (
            <styled.Main ref={this.main}>
                <ResizeObserver onResize={this.onResize.bind(this)}></ResizeObserver>
                <styled.GlobalStyle />
                <Grid />
                <Menu isMobileVersion={this.isMobileVersion()} />
                <Logo isMobileVersion={this.isMobileVersion()} screenHeight={this.state.screenHeight} />
                <About isMobileVersion={this.isMobileVersion()} />
                <Scroller isMobileVersion={this.isMobileVersion()} rowHeight={this.state.screenHeight} />
                <Magnify isMobileVersion={this.isMobileVersion()} />
            </styled.Main>
        );
    }
}

export default Main;